import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { Button } from 'grommet/components/Button';
import { RadioButton } from 'grommet/components/RadioButton';
import AccessibleSelect from '../Components/AccessibleSelect';
import ReactTable from 'react-table';
import { DisputeCtrl } from '../Controllers/Disputes/DisputeCtrl';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { loader, noData, formatAmount } from '../Utils/Utility';


class DifferenzeContabili extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      search: '',
      checked: 'ALL',
      selectedMonthYear: '',
      selectedMonthYearLabel: '',
      selected: {},
      showresult: false,
      value: [],
      months: [],
      numericMonths: [],
      showTimeoutModal: false,
      status:'',
      isRicerca: false,
      firstTimeMount: false
    }
    this.setRadioButton = this.setRadioButton.bind(this);
    this.setSelectionMonthYear = this.setSelectionMonthYear.bind(this);
    this.showResult = this.showResult.bind(this);
  }


  setPoint(i) {
    const newSelected = this.state.selected;
    const newValue = this.state.value;
    newSelected[i] = !this.state.selected[i];
    newValue[i] = [i];

    this.setState({
      selected: newSelected,
      value: newValue
    })
  }

  setRadioButton(event) {
    this.setState({
      checked: event.target.value
    })
  }

  componentDidMount() {

    var date = new Date();
    var months = []
    var numericMonths = [],
      monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
    
    for (var i = 0; i < 13; i++) {
      var calMonth = 1 + date.getMonth()
      var tempMonth = calMonth < 10 ? '0' + calMonth : calMonth

      months.push(monthNames[date.getMonth()] + ' ' + date.getFullYear());
      numericMonths.push(date.getFullYear() + '' + tempMonth);
      date.setMonth(date.getMonth() - 1);

    }
    //console.log(months)
    return this.setState({ months, numericMonths })

  }


  setSelectionMonthYear(event) {
    // Estrae il valore dall'oggetto dell'opzione selezionata
    const selectedValue = event.option ? event.option.value : '';
    const selectedIndex = this.state.months.findIndex(month => month === selectedValue);
    var val = selectedIndex >= 0 ? this.state.numericMonths[selectedIndex] : '';
    
    this.setState({
      selectedMonthYearLabel: selectedValue,
      selectedMonthYear: val
    })
    //console.log(this.state.selectedMonthYear)
    //console.log(this.state.selectedMonthYearLabel)
  }


  showResult(typeCall) {
    var token = sessionStorage.getItem('token')
    var ids = sessionStorage.getItem('ids')
    const self = this;
    this.setState({
      firstTimeMount: true,
      isRicerca: true
    },()=>{
      DisputeCtrl(function (data) {
        self.setState({
          dataTable: data === '' ? [] : data.disputeList,
          isRicerca: false,
          showresult: true
        });
      }, function (error) {
        self.setState({
          status: error
        }, function(){
          if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
              this.props.history.push({
                  pathname: '/ErrorPage',
                  state: this.state
              })  
          } else if (this.state.status === 401) {
            this.setState({
              showTimeoutModal: true
            })
              // logout();
              // this.props.history.push({
              //   pathname: '/login'
              // })
          } 
      })

      }, this.state, typeCall, token, ids);
    });
  }


  render() {

    const columns = [
      {
        Header: 'CODICE ESERCIZIO',
        accessor: 'branchCode',
        headerClassName: 'sH',
        style: {
          fontSize: '10px'
        }
      },
      {
        Header: 'DATA LETTERA',
        accessor: 'dataLettera',
        headerClassName: 'sH',
        style: {
          fontSize: '10px'
        }
      },
      {
        Header: 'IMPORTO NETTO',
        accessor: 'importoDisputa',
        headerClassName: 'sH',
        style: {
          fontSize: '10px'
        },
        Cell: (row) => formatAmount(row.original.importoDisputa)
      },
      {
        Header: 'NUMERO PRATICA',
        accessor: 'numeroPratica',
        headerClassName: 'sH',
        style: {
          fontSize: '10px'
        }
      }
    ]

    const hasData = (Array.isArray(this.state.dataTable) && this.state.dataTable.length > 0 && this.state.dataTable !== null && this.state.dataTable !== undefined)

    return (
      <Box>
        {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
        <Box align='center' className='content differenze-page' pad='medium' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>

          <Box className='contentbox'>
            <Box align='start' style={{ paddingBottom: '50px' }}>
              <Text className='titlehome'><h1>Consulta Dettaglio Differenze Contabili</h1></Text>
              <Text className='subtitlehome'><h3>Seleziona i filtri di ricerca</h3></Text>
            </Box>

            <Box align='center' id='searchdiff' justify='center' className=' box-diff-contabili' >
              <Text className='titlesectionhome' id='periodo-temporale-section'><h3>PERIODO TEMPORALE</h3></Text>

              <Box className='genericext box-search-diff' direction='row' gap='small' style={{ marginTop: '10px' }}>
                <Box className='nomargindiff'>
                  <Text className='label' htmlFor='year' id='year-label' aria-hidden="false"><h5>MESE E ANNO*</h5></Text>
                  <AccessibleSelect
                    id='year'
                    className='select'
                    placeholder='Seleziona Mese'
                    options={this.state.months.map(month => ({
                      label: month,
                      value: month,
                      'aria-label': month
                    }))}
                    labelKey='label'
                    valueKey='value'
                    value={this.state.selectedMonthYearLabel ? {
                      label: this.state.selectedMonthYearLabel,
                      value: this.state.selectedMonthYearLabel,
                      'aria-label': this.state.selectedMonthYearLabel
                    } : ''}
                    onChange={this.setSelectionMonthYear}
                    aria-labelledby='year-label periodo-temporale-section'
                    aria-required='true'
                    a11yTitle='Mese e anno'
                    dropAlign={{ top: 'bottom' }}
                    dropProps={{
                      a11yTitle: 'Opzioni di mese e anno disponibili',
                      role: 'listbox',
                      'aria-multiselectable': 'false'
                    }}
                    messages={{
                      multiple: 'Selezionato',
                      selected: 'Selezionato'
                    }}
                  />
                </Box>
                <Box direction='column' className='nomargindiff'>
                  <Text className='label' id='tipologia-label'><h5>TIPOLOGIA</h5></Text>
                  <Box direction='row' className='rowColumn' role='radiogroup' aria-labelledby='tipologia-label'>
                    <RadioButton 
                      id='tutte' 
                      label='Tutte' 
                      className='radiobutton' 
                      checked={this.state.checked === 'ALL'} 
                      onChange={this.setRadioButton} 
                      value='ALL'
                      aria-checked={this.state.checked === 'ALL'}
                      name='tipologia'
                      onKeyDown={(e) => {
                        // Gestione tasti freccia per navigare tra i radio button
                        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                          if (this.state.checked === 'ALL') this.setRadioButton({ target: { value: 'DRN' } });
                          else if (this.state.checked === 'DRN') this.setRadioButton({ target: { value: 'MAN' } });
                          else if (this.state.checked === 'MAN') this.setRadioButton({ target: { value: 'ALL' } });
                        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                          if (this.state.checked === 'ALL') this.setRadioButton({ target: { value: 'MAN' } });
                          else if (this.state.checked === 'DRN') this.setRadioButton({ target: { value: 'ALL' } });
                          else if (this.state.checked === 'MAN') this.setRadioButton({ target: { value: 'DRN' } });
                        }
                      }}
                    />
                    <RadioButton 
                      id='differenze' 
                      label='Differenze Contabili' 
                      className='radiobutton' 
                      checked={this.state.checked === 'DRN'} 
                      onChange={this.setRadioButton} 
                      value='DRN'
                      aria-checked={this.state.checked === 'DRN'}
                      name='tipologia'
                      onKeyDown={(e) => {
                        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                          if (this.state.checked === 'ALL') this.setRadioButton({ target: { value: 'DRN' } });
                          else if (this.state.checked === 'DRN') this.setRadioButton({ target: { value: 'MAN' } });
                          else if (this.state.checked === 'MAN') this.setRadioButton({ target: { value: 'ALL' } });
                        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                          if (this.state.checked === 'ALL') this.setRadioButton({ target: { value: 'MAN' } });
                          else if (this.state.checked === 'DRN') this.setRadioButton({ target: { value: 'ALL' } });
                          else if (this.state.checked === 'MAN') this.setRadioButton({ target: { value: 'DRN' } });
                        }
                      }}
                    />
                    <RadioButton 
                      id='transazione' 
                      label='Transazione Annullata' 
                      className='radiobutton' 
                      checked={this.state.checked === 'MAN'} 
                      onChange={this.setRadioButton} 
                      value='MAN'
                      aria-checked={this.state.checked === 'MAN'}
                      name='tipologia'
                      onKeyDown={(e) => {
                        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                          if (this.state.checked === 'ALL') this.setRadioButton({ target: { value: 'DRN' } });
                          else if (this.state.checked === 'DRN') this.setRadioButton({ target: { value: 'MAN' } });
                          else if (this.state.checked === 'MAN') this.setRadioButton({ target: { value: 'ALL' } });
                        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                          if (this.state.checked === 'ALL') this.setRadioButton({ target: { value: 'MAN' } });
                          else if (this.state.checked === 'DRN') this.setRadioButton({ target: { value: 'ALL' } });
                          else if (this.state.checked === 'MAN') this.setRadioButton({ target: { value: 'DRN' } });
                        }
                      }}
                    />
                  </Box>
                </Box>
                
              
              </Box>
              <Box id='camp' className='nomargindiff genericext' alignSelf='start'>
                  <Text className='suggestion'><h5>*Campi obbligatori</h5></Text>
              </Box>
              
              <Box style={{margin:'30px 0 40px'}}>
                <Button
                  className={!this.state.selectedMonthYearLabel ? 'btnsearchForm disabled' : 'btnsearchForm'}
                  onClick={() => this.showResult()}
                  disabled={!this.state.selectedMonthYearLabel}
                  aria-label="Cerca differenze contabili con i filtri selezionati"
                  role="button"
                >
                  <i className='icon-magnifying-glass' style={{ fontSize: '20px', fontStyle: 'normal', marginRight: '5px' }} aria-hidden="true"></i>
                  CERCA
                </Button>
              </Box>
            </Box>

            <Box direction='row' style={{ padding: '0 2%' }}>
              <Box pad='large' style={{ width: '100%', padding: '0' }}>
                {this.state.showresult && hasData
                  ? <ReactTable
                      data={this.state.dataTable}
                      columns={columns}
                      sortable={true}
                      resizable={true}
                      showPagination={false}
                      loading={false}
                      defaultPageSize={this.state.dataTable.length}
                      style={{ paddingBottom: '20px' }}
                    />
                  : this.state.isRicerca
                    ? loader
                    : noData
                }
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }
}
export default DifferenzeContabili;